<template>
    <div>
        <b-navbar toggleable="md" variant="primary" type="dark">
            <b-navbar-brand :to="{ name: 'Membership' }">Portal</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item :to="{ name: 'Membership' }" :active="$route.name === 'Membership'">Membresías</b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item class="mr-2" :active="true">
                        <font-awesome-icon icon="user-circle"></font-awesome-icon> {{user.name}}
                    </b-nav-item>
                    <b-nav-item class="ml-2" :href="SUPER_ADMIN_DOCS" target="_blank" :active="true" v-b-tooltip.hover.bottom title="Ayuda">
                        <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </b-nav-item>
                    <b-nav-item class="ml-2" @click="logOut" :active="true" v-b-tooltip.hover.bottom title="Cerrar sesión">
                        <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <b-breadcrumb v-if="$route.name !== 'Membership' && $route.name !== 'Profile'" :items="breadcrumbItems"></b-breadcrumb>
        <router-view :settings="settings" @update-breadcrumb-items="updateBreadcrumbItems"></router-view>
    </div>
</template>

<script>

import { superAdminlogOutUrl, clientTokenUrl, settingUrl } from '@routes';
import * as constants from '@/js/constants';

export default {
    data() {
        return {
            user: {
                id: 0,
                name: '',
                email: ''
            },
            settings: {
                id: 0,
                theme: {
                    variant: 'light'
                }
            },
            breadcrumbItems: []
        }
    },
    created() {
        let userSettings = null;

        if (localStorage.getItem('userSettings')) {
            userSettings = JSON.parse(localStorage.getItem('userSettings'));

            if ('theme' in userSettings) {
                this.settings.theme = userSettings.theme;
            }
        }

        let user = JSON.parse(localStorage.getItem('userInfo'));

        if (user) {
            this.user.id = user.id;
            this.user.name = user.name;
        }

        // this.loadData();
    },
    /*mounted() {
        let $this = this;

        function requestPermission() {
            console.log('Requesting permission...');
            Notification.requestPermission().then(permission => {
                if (permission === 'granted') {
                    console.log('Notification permission granted.');
                    resetUI();
                } else {
                    console.log('Unable to get permission to notify.');
                }
            });
        }

        messaging.onTokenRefresh(() => {
            messaging.getToken().then(refreshedToken => {
                console.log('Token refreshed.');
                $this.axios.post(clientTokenUrl(), { token: refreshedToken });
                resetUI();
            }).catch(err => {
                console.log('Unable to retrieve refreshed token.', err);
            });
        });

        function resetUI() {
            messaging.getToken().then(currentToken => {
                if (currentToken) {
                    $this.axios.post(clientTokenUrl(), { token: currentToken });
                } else {
                    console.log('No Instance ID token available. Request permission to generate one.');
                }
            }).catch(err => {
                console.log('An error occurred while retrieving token.', err);
            });
        }

        requestPermission();

        messaging.onMessage(payload => {
            this.$root.$bvToast.toast(payload.notification.body, {
                title: payload.notification.title,
                variant: 'info'
            });
        });
    },*/
    methods: {
        /*loadData() {
            return new Promise(resolve => {
                this.axios.get(settingUrl()).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        let membership = response.data.membership;

                        this.customer.id = membership.id;
                        this.customer.name = this.capitalize(membership.name);
                        this.customer.email = membership.contactEmail;
                        this.customer.phone = membership.contactPhone;
                    }
                }).catch(() => {

                }).finally(resolve);
            });
        },*/
        logOut() {
            this.axios.delete(superAdminlogOutUrl()).finally(() => {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('clientId');
                localStorage.removeItem('clientSecret');

                this.user = {
                    id: 0,
                    name: '',
                    email: ''
                };

                this.$router.replace({ name: 'SuperAdminLogin' });
            });
        },
        updateBreadcrumbItems(items) {
            this.breadcrumbItems = items;
        },
        capitalize(value) {
            if (!value) {
                return '';
            }

            value.toString();

            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    computed: {
        SUPER_ADMIN_DOCS() {
            return constants.SUPER_ADMIN_DOCS;
        }
    }
}
</script>

<style>

</style>